module.exports = __webpack_public_path__ + "media/luxury-2026/glass-ceiling-entry-960-01e9b223.jpg";